export enum PhItemCategoryEnum{
    PTRIM ='CARTONS',
    POLYBAGS ='POLYBAGS',
    FABRIC = 'FABRIC'
}